import React, { Component } from 'react';
import {
  Link,
} from 'react-router-dom';
import WV from './assets/west-vesey.svg';

const Footer = () =>
  <footer className="footer">
    <div className="container">
      <div className="content has-text-centered">
        <p className="has-text-weight-semibold has-text-white is-size-4">
          Questions? <span style={{fontWeight: '400'}}>Send us an email or chat with us over here 👉</span>
        </p>
        <p className="has-text-weight-medium has-text-white">
          <span style={{opacity:.7}}>© 2018 Scribble &nbsp;&nbsp;•&nbsp;&nbsp; </span>🚀 <span style={{opacity:.7}}>in NYC</span>
        </p>
        <a href="https://www.westvesey.com/?ref=scribble" target="_blank">
          <img
          src= { WV }
          style= {{height:"40px"}}
          />
        </a>
      </div>
    </div>
  </footer>

export default Footer;



// WEBPACK FOOTER //
// ./src/footer.js